import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class StickyResource extends ThemeComponent {

    private stickyResource: HTMLElement|null = null;

    init() {
        this.stickyResource = document.querySelector('.sticky-resource__wrapper') as HTMLElement;

        window.addEventListener('scroll', () => {
            if (window.scrollY > 0) {
                this.stickyResource?.classList.remove('sticky-resource--active');
            } else {
                this.stickyResource?.classList.add('sticky-resource--active');
            }
        });

        if (this.stickyResource) {
            this.handleClickEvent();
        }
    }

    handleClickEvent() {
        this.stickyResource?.addEventListener('click', () => {
            this.stickyResource?.classList.toggle('sticky-resource--active');
        });
    }
}
